const baseURL = "https://ganeshtiles.in/api";

export default baseURL;

